import { TappableAreaMetadata } from 'src/common/types/MobileSingleSessionTypes';

export const getTappableAreaSizeText = ({
	actualWidth,
	actualHeight,
	expectedWidth,
	expectedHeight,
	elementSizeUnit
}: TappableAreaMetadata): string =>
	`The actual size of this element is ${Math.round(actualWidth)}${elementSizeUnit} x ${Math.round(
		actualHeight
	)}${elementSizeUnit}. Consider increasing its size to at least ${Math.round(
		expectedWidth
	)}${elementSizeUnit} x ${Math.round(expectedHeight)}${elementSizeUnit}.`;
